export const valueGetter = (key, { affectedTotals } = {}) => ({ data }) => ({
  data: data[key],
  key,
  type: data.type,
  affectedTotals,
});

export const isCellEditable = (columnName, editableColumns, nonEditableRows = []) => node => {
  const isColumntEditable = editableColumns && editableColumns.length
    ? !!editableColumns.find(({ key }) => key === columnName)
    : false;

  if (!isColumntEditable) {
    return false;
  }
  const { data } = node;

  if (!nonEditableRows.length) {
    return true;
  }

  return !nonEditableRows.find(({ key, value }) => data[key] === value);
};

export const isGroupReportCellEditable = (columnName, editableColumns) => node => {
  const { taxYearForEditableChecks, TAX_ENTRY_TYPE } = node.data;
  const editable = editableColumns.find(
    column => column.taxYear === taxYearForEditableChecks && column.entryType === TAX_ENTRY_TYPE
  );

  if (!editable) {
    return false;
  }

  const isEditable = editable.editableColumns.some(({ key }) => key === columnName);

  return isEditable;
};

export const findEditableDataForGroupReport = (columnName, editableColumns = []) => params => {
  const { data } = params;
  const { TAX_ENTRY_TYPE: entryType, taxYearForEditableChecks: taxYear } = data;

  const editableRow = editableColumns.find(editableRow => editableRow.entryType === entryType
    && editableRow.taxYear === taxYear
  );

  if (!editableRow) {
    return null;
  }

  return {
    formOptions: editableRow.editableColumns.find(column => column.key === columnName),
  };
};

export const suppressAnyKeyboardEventInEdition = params => {
  const arrowKeyCodes = [
    'ArrowUp',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
  ];

  if (arrowKeyCodes.includes(params.event.key) || arrowKeyCodes.includes(params.event.code)) {
    return false;
  }

  if (params.editing) {
    return true;
  }

  return false;
};
